{{ value | date : column?.options?.format || 'dd-MM-yyyy HH:mm' }}
